/**
 * GiftCardsFilterSelect — one labeled dropdown in the gift-cards toolbar
 * (BON-223): Status or Source. Both axes are short closed enums, so the
 * value stays visible in the toolbar rather than hiding behind a badge.
 */
export interface GiftCardsFilterSelectProps<T extends string> {
  label: string;
  value: T;
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
}

export function GiftCardsFilterSelect<T extends string>({
  label,
  value,
  options,
  onChange,
}: GiftCardsFilterSelectProps<T>) {
  const on = value !== 'all';
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 30,
        flex: '0 0 auto',
        padding: '0 8px 0 10px',
        border: '1px solid',
        borderRadius: 8,
        background: on ? 'var(--nb-primary-soft)' : 'var(--nb-bg)',
        borderColor: on ? 'var(--nb-primary)' : 'var(--nb-border)',
      }}
    >
      <span
        style={{
          fontSize: 10.5,
          fontWeight: 800,
          letterSpacing: '.04em',
          textTransform: 'uppercase',
          color: on ? 'var(--nb-primary-2)' : 'var(--nb-subtle)',
        }}
      >
        {label}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        style={{
          border: 0,
          background: 'transparent',
          font: 'inherit',
          fontSize: 12.5,
          fontWeight: 600,
          color: 'var(--nb-ink)',
          cursor: 'pointer',
          outline: 'none',
          maxWidth: 150,
        }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
